<template>
    <div>
        <div class="col-12">
            <TitleComponent title="Selecciona tus entradas:"/>
        </div>
        <div class="col-12">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ $t('evento.tipo_entrada') }}</th>
                        <th>Precio</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(entrada, index) in entradas" :key="index">
                        <td :class="capPara(entrada) > 0 ? 'availability' : 'bg-danger'"></td>
                        <td>{{ entrada.descripcion }}</td>
                        <td>{{ getPrecioEntrada(entrada) | formatear_precio }}</td>
                        <td>
                            <div class="form-group" v-if="capPara(entrada) > 0">
                                <select
                                    class="form-control"
                                    data-cy="selector-entradas-taquilla"
                                    v-model="entrada.unidades"
                                    @change="actualizar"
                                    :disabled="disableInput"
                                    :aria-label="selectorAriaLabel(entrada)"
                                >
                                    <option value="0">0</option>
                                    <option
                                        v-for="i in capPara(entrada)"
                                        :key="i"
                                        :value="i"
                                    >
                                        {{ i }}
                                    </option>
                                </select>
                            </div>
                            <template v-else>
                                <b class="text-danger" role="status">ENTRADAS AGOTADAS</b>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
    import { computed, toRef } from 'vue';
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import { useCupoPorEntrada } from '@/composables/admin/events/sesiones/useCupoPorEntrada';

    const props = defineProps({
        entradas: {
            type: Array,
            required: true,
        },
        sesion: {
            type: Object,
            default: null,
        },
        disableInput: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits(['actualizar']);

    const entradasRef = toRef(props, 'entradas');

    const stockCompartido = computed(() => Boolean(props.sesion?.stock_compartido));
    const cupoCompartido = computed(() => {
        if (!stockCompartido.value) {
            return null;
        }
        // Pass through NaN/negative so the composable's FAILSAFE branch can
        // surface a drift error instead of silently going to the legacy path.
        return Number(props.sesion?.cupo_disponible);
    });
    const preventaActiva = computed(() => Boolean(props.sesion?.preventa?.venta_preventa_activa));
    const preventaMax = computed(() => {
        if (!preventaActiva.value) {
            return null;
        }
        const raw = props.sesion?.n_max_asientos;
        const numeric = Number(raw);
        return Number.isFinite(numeric) ? numeric : null;
    });

    const capPara = useCupoPorEntrada(entradasRef, cupoCompartido, preventaMax);

    function actualizar() {
        emit('actualizar', true);
    }

    function getPrecioEntrada(entrada) {
        if (entrada.price_management_taquilla_interno) {
            return entrada.precio;
        }

        return entrada.total_price;
    }

    // REQ-NF-A11Y-01: aria-label reflects the current cap when the
    // stock_compartido branch is active. Falls back to descripcion
    // for the legacy branch.
    function selectorAriaLabel(entrada) {
        const cap = capPara(entrada);

        if (stockCompartido.value && Number.isFinite(cap) && cap >= 0) {
            return `${entrada.descripcion} (máximo ${cap})`;
        }

        return entrada.descripcion;
    }
</script>